import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';

const Item = styled.div`
  width: 22.7%;
  background: #fff;
  border: 1px solid #E0E0E0;
  box-sizing: border-box;
  border-radius: 4px;
  padding-top: 76px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media only screen and (max-width: 1919px) {
    padding-top: 61px;
  }

  @media only screen and (max-width: 1365px) {
    padding-top: 35px;
    width: 49%;

    &:nth-child(3),
    &:nth-child(4) {
      margin-top: 22px;

      @media only screen and (max-width: 1023px) {
        margin-top: 66px;
      }
    }
  }

  @media only screen and (max-width: 1023px) {
    padding-top: 61px;
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-top: 32px;

    &:first-child {
      margin-top: 0;
    }

    &:nth-child(3),
    &:nth-child(4) {
      margin-top: 32px;
    }
  }
`;

const TariffIcon = styled.div`
  width: 76px;
  height: 76px;
  fill: #333;
  border: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media only screen and (max-width: 1919px) {
    width: 62px;
    height: 62px;
  }
`;

const TariffTitle = styled.p`
  margin-top: 50px;
  ${FONTS.XXL};

  @media only screen and (max-width: 1919px) {
    ${FONTS.L};
    margin-top: 47px;
  }

  @media only screen and (max-width: 1365px) {
    margin-top: 22px;
  }

  @media only screen and (max-width: 1023px) {
    ${FONTS.XXL};
  }

  @media only screen and (max-width: 767px) {
    margin-top: 36px;
  }
`;

const TariffDesc = styled.p`
  width: 100%;
  margin-top: 10px;
  ${FONTS.L};
  color: #828282;
  padding: 0 29px;
  flex: 1 0 auto;

  @media only screen and (max-width: 1919px) {
    ${FONTS.S};
    padding: 0 18px;
  }

  @media only screen and (max-width: 1365px) {
    margin-top: 0;
    padding: 0 25px;
  }

  @media only screen and (max-width: 1023px) {
    ${FONTS.L};
  }

  @media only screen and (max-width: 767px) {
    margin-top: 10px;
    padding: 0 18px;
  }
`;

const TariffPrice = styled.span`
  width: 100%;
  margin-top: 45px;
  background: #F5F5F5;
  padding: 24px;
  text-align: center;
  ${FONTS.XXL};
  flex: 1 0 auto;

  @media only screen and (max-width: 1365px) {
    padding: 15px;
    margin-top: 27px;
    max-height: 63px;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 43px;
    max-height: 81px;
    padding: 25px 15px 25px;
  }
`;

export default class TariffItem extends Component {
  static propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    price: PropTypes.string,
  };

  render() {
    const { className, icon, title, desc, price } = this.props;

    return (
      <Item className={className}>
        <TariffIcon>
          <img src={icon} alt=''/>
        </TariffIcon>
        <TariffTitle>{title}</TariffTitle>
        <TariffDesc>{desc}</TariffDesc>
        <TariffPrice>{price}</TariffPrice>
      </Item>
    );
  }
}
